import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=1dbb5118&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=1dbb5118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbb5118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbb5118')) {
      api.createRecord('1dbb5118', component.options)
    } else {
      api.reload('1dbb5118', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=1dbb5118&scoped=true&", function () {
      api.rerender('1dbb5118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Editor.vue"
export default component.exports